import React from 'react';

import { Field } from 'react-final-form';
import { RenderField } from 'forms';

export interface Props {
    name: string;
    validate?: any;
}

export default class ProductUnitsPerAreaField extends React.PureComponent<
    Props
> {
    render(): React.ReactElement | null {
        const { name, validate } = this.props;

        return (
            <Field
                name={`${name}.units`}
                component={RenderField as any}
                subscription={{
                    value: true,
                    touched: true,
                    error: true
                }}
                label="Rate"
                type="number"
                nullOnUnmount={false}
                validate={validate}
            />
        );
    }
}
